import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import localForage from 'localforage';
import router from './router';
import firebase from 'firebase/app';
import 'firebase/auth';

Vue.use(Vuex);

const vuexStorage = new VuexPersist({
  storage: localForage,
  // You can change this explicitly use
  // either window.localStorage  or window.sessionStorage
  // However we are going to make use of localForage
});

export default new Vuex.Store({
  plugins: [vuexStorage.plugin],
  state: {
    submissionFormOpen: false,
    userId: null,
    user: null,
  },
  getters: {
    loggedIn: state => !!state.user,
  },
  mutations: {
    toggleForm(state) {
      state.submissionFormOpen = !state.submissionFormOpen;
    },
    login(state, payload) {
      state.user = payload.email;
      state.userId = payload.uid;
    },
    logout(state) {
      state.user = '';
      state.userId = '';
    },
  },
  actions: {
    toggleForm(context) {
      context.commit('toggleForm');
    },
    login({ commit }, authData) {
      return new Promise((resolve, reject) => {
        firebase.auth().signInWithEmailAndPassword(authData.email, authData.password)
          .then(() => {
            firebase.auth().onAuthStateChanged((authUser) => {
              commit('login', authUser);
              resolve();
            });
          })
          .catch(err => reject(err.message));
      });
    },
    signUp({ commit }, user) {
      return new Promise((resolve, reject) => {
        firebase
          .auth()
          .createUserWithEmailAndPassword(user.email, user.password)
          .then(() => {
            firebase.auth().onAuthStateChanged(authUser => {
              commit('login', authUser);
              resolve();
            });
          })
          .catch((err) => {
            reject(err.message);
          });
      });
    },
    logout({ commit }) {
      firebase.auth().signOut().then(() => {
        firebase.auth().onAuthStateChanged(authUser => {
          commit('logout', authUser);
          router.push('/login');
        });
      });
    },
  },
});
